import { render, staticRenderFns } from "./FeesView.vue?vue&type=template&id=4adfdbfe&scoped=true&"
import script from "./FeesView.vue?vue&type=script&lang=js&"
export * from "./FeesView.vue?vue&type=script&lang=js&"
import style0 from "./FeesView.vue?vue&type=style&index=0&id=4adfdbfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adfdbfe",
  null
  
)

export default component.exports